var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.5C11.4477 14.5 11 14.9477 11 15.5C11 16.0523 11.4477 16.5 12 16.5C12.5523 16.5 13 16.0523 13 15.5C13 14.9477 12.5523 14.5 12 14.5Z",
    stroke: "#E7DFD0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.5C4.44772 14.5 4 14.9477 4 15.5C4 16.0523 4.44772 16.5 5 16.5C5.55228 16.5 6 16.0523 6 15.5C6 14.9477 5.55228 14.5 5 14.5Z",
    stroke: "#E7DFD0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14.5C18.4477 14.5 18 14.9477 18 15.5C18 16.0523 18.4477 16.5 19 16.5C19.5523 16.5 20 16.0523 20 15.5C20 14.9477 19.5523 14.5 19 14.5Z",
    stroke: "#E7DFD0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5C11.4477 7.5 11 7.94772 11 8.5C11 9.05228 11.4477 9.5 12 9.5C12.5523 9.5 13 9.05228 13 8.5C13 7.94772 12.5523 7.5 12 7.5Z",
    stroke: "#E7DFD0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.5C4.44772 7.5 4 7.94772 4 8.5C4 9.05228 4.44772 9.5 5 9.5C5.55228 9.5 6 9.05228 6 8.5C6 7.94772 5.55228 7.5 5 7.5Z",
    stroke: "#E7DFD0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 7.5C18.4477 7.5 18 7.94772 18 8.5C18 9.05228 18.4477 9.5 19 9.5C19.5523 9.5 20 9.05228 20 8.5C20 7.94772 19.5523 7.5 19 7.5Z",
    stroke: "#E7DFD0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreHorizontal);
export default __webpack_public_path__ + "static/media/more-horizontal.3babab631f24734f1dd45c82a56cefcc.svg";
export { ForwardRef as ReactComponent };